export default __webpack_public_path__ + "static/media/EESymbolsImg15.e1194f6b.jpg";